import { AppState } from '../root.reducer';

export const getCurrentTenancyUser = (state: AppState) => state.tenancyUser.currentTenancyUser;
